export default __webpack_public_path__ + "static/media/60_sec_2nd_cut.b0db36e4.mp3";